let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jMchi")).then(() => parcelRequire('6tsQH'));